import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import CheckoutViews from "views/checkout-views";
import { AUTH_PREFIX_PATH } from "configs/AppConfig";

const CheckoutLayout = ({ token, direction }) => {
	if (!token) {
		const currentPath = window.location.hash.replace("#", "");
		return (
			<Redirect
				to={`${AUTH_PREFIX_PATH}/login?redirect=${encodeURIComponent(currentPath)}`}
			/>
		);
	}

	return (
		<div
			className={`app-layout-blank ${direction === "rtl" ? "ant-rtl" : ""}`}
		>
			<div
				style={{
					maxWidth: 800,
					margin: "0 auto",
					padding: "40px 24px",
					minHeight: "100vh",
				}}
			>
				<CheckoutViews />
			</div>
		</div>
	);
};

const mapStateToProps = ({ auth }) => ({
	token: auth.token,
});

export default connect(mapStateToProps)(CheckoutLayout);
